'use client';

import { ProfileEditForm } from '@eliadmin/core/src/components/profile/profile-edit-form';

export default function Page() {
  return (
    <section>
      <ProfileEditForm />
    </section>
  );
}
